import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  routeTemplateForPath,
  setCurrentPage,
  startWebsiteTracking,
  stopWebsiteTracking,
} from "@/lib/analytics/website";
import {
  flushWebsiteActivityPage,
  setWebsiteActivityPage,
  startWebsiteActivity,
  stopWebsiteActivity,
} from "@/lib/analytics/activity";

export default function WebsiteTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    startWebsiteTracking();
    startWebsiteActivity();
    return () => {
      stopWebsiteActivity();
      stopWebsiteTracking();
    };
  }, []);

  useEffect(() => {
    flushWebsiteActivityPage();
    setCurrentPage(routeTemplateForPath(pathname), pathname);
    setWebsiteActivityPage(pathname, search);
  }, [pathname, search]);

  return null;
}
